import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import NotFound from 'pages/NotFound'
import DeviceMetricForm from 'pages/shared/DeviceMetricForm'

import useTrends from 'hooks/useTrends'

import Api from 'services/api'

import { PageHeader, PageTitle, LoadingSinglePanePage, SinglePanePage, screenSize } from 'styles/shared'

const EditDeviceMetric = () => {
  useTrends()

  const [metric, setMetric] = useState(null)
  const [isMetricLoaded, setIsMetricLoaded] = useState(false)

  const { id } = useParams()

  useEffect(() => {
    if (isMetricLoaded || id == null) {
      return
    }

    setMetric(null)
    setIsMetricLoaded(false)

    Api.DeviceMetrics.get(id)
      .then(res => {
        setMetric(res)
      })
      .catch(() => {
        setMetric(null)
        setIsMetricLoaded(true)
      })
      .finally(() => {
        setIsMetricLoaded(true)
      })
  }, [id, isMetricLoaded, setMetric, setIsMetricLoaded])

  if (!(isMetricLoaded)) {
    return <LoadingSinglePanePage />
  }

  return (
    <>
      <PageHeader>
        <S.PageTitle>Edit Device Metric</S.PageTitle>
      </PageHeader>
      <S.SinglePanePage>
        {
           metric ? <DeviceMetricForm
           validatedSaveType="update"
           deviceMetric={metric}
                    /> : <NotFound />
        }

      </S.SinglePanePage>
    </>
  )
}

export default EditDeviceMetric

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
